import { Component, Input } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal, MzToastService } from "ng2-materialize";
import { Utils } from "../../utils/utils";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";
import { Retrospective } from "../../interfaces/retrospective";

@Component({
  selector: "app-retrospective-wizard-4-results",
  templateUrl: "./retrospective-wizard-4-results.component.html",
  styleUrls: ["./retrospective-wizard-4-results.component.scss"],
})
export class RetrospectiveWizardResultsComponent extends MzBaseModal {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() retrospective: Retrospective;

  result: boolean;
  date: Date = new Date();

  constructor(
    private projectService: ProjectService,
    private toastService: MzToastService,
    private planningPokerService: PlanningPokerService
  ) {
    super();
  }

  ngAfterViewInit() {}

  async show(): Promise<boolean> {
    this.result = undefined;
    this.modalComponent.open();
    await this.modalComponent.onClose
      .map((_) => true)
      .first()
      .toPromise();
    return this.result;
  }

  confirm() {
    this.result = true;
    this.modalComponent.close();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/retrospective-wizard-4-results/retrospective-wizard-4-results.component.ts